import { Animation, AnimationController } from '@ionic/angular';
import { AnimationBuilder } from '@angular/animations';

export function modalOpenAnimation(
  baseEl: any,
  opts?: any
): Animation {
  const baseAnimation = new AnimationController().create();
  const backdropAnimation = new AnimationController().create();
  const wrapperAnimation = new AnimationController().create();

  wrapperAnimation
    .addElement(baseEl.shadowRoot.querySelector('.modal-wrapper'))
    .keyframes([
      { offset: 0, opacity: '0', transform: 'translateX(100%)' },
      { offset: 1, opacity: '0.99', transform: 'translateX(0)' },
    ]);

  backdropAnimation
    .addElement(baseEl.shadowRoot.querySelector('ion-backdrop'))
    .fromTo('opacity', 0.01, 0.4);

  return baseAnimation
      .addElement(baseEl)
      .easing('ease-in-out')
      .duration(400)
      .beforeAddClass('show-modal')
      .addAnimation([backdropAnimation, wrapperAnimation]);
}
